import moment from 'moment';
import { Organization } from './Organization';

export enum FunctionSalesforce {
    BUSCA_EXTRATO = 'ID_BuscaExtrato',
    INTEGRADOR_CONTABIL = 'ID_Integrador',
    TAREFFA = 'ID_GestaoServicos',
    TICKET_OPENING = 'ID_Atendimento',
}

export class User {

    static Type = class {
        static ADMINISTRATOR = 0;
        static ACCOUNTANT = 1;
        static CUSTOMER = 2;
    };

    id: number;
    username: string;
    password: string;

    activated: boolean;
    type: number;

    avatar: string;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;

    organization: Organization;
    private userFunctions: {
        expiresAt?: string;
        salesForceId: FunctionSalesforce;
        name: string;
    }[];

    constructor() {
    }

    static fromLocalStorage(): User {
        const storedUser = JSON.parse(localStorage.getItem('user-info') || '{}');
        const user = new User();
        if (storedUser !== null && typeof storedUser !== 'undefined') {
            if (storedUser.username !== null && typeof storedUser.username !== 'undefined') {
                user.id = storedUser.id;
                user.username = storedUser.username;
                user.password = storedUser.password;
                user.activated = storedUser.activated;
                user.type = storedUser.type;
                user.userFunctions = storedUser.userFunctions;
                user.avatar = storedUser.avatar;
                user.email = storedUser.email;
                user.firstName = storedUser.firstName;
                user.lastName = storedUser.lastName ?? '';
                user.phone = storedUser.phone;
                user.organization = storedUser.organization;
                return user;
            }
        }

        return user;
    }

    public isAdministrator() {
        return this.type === User.Type.ADMINISTRATOR || this.type >= 7;
    }

    private validatePermission(id: FunctionSalesforce): boolean {
        if (this.isAdministrator()) {
            return true;
        }
        const fn = this.userFunctions?.find((fn) => fn.salesForceId === id);
        return (
            !!fn && moment(fn.expiresAt).isAfter(moment().subtract(1, 'day'))
        );
    }

    public get hasBuscaExtrato() {
        return this.validatePermission(FunctionSalesforce.BUSCA_EXTRATO);
    }

    public get hasIntegrador() {
        return this.validatePermission(FunctionSalesforce.INTEGRADOR_CONTABIL);
    }

    public get hasTareffa() {
        return this.validatePermission(FunctionSalesforce.TAREFFA);
    }

    public get hasAtendimentoCliente() {
        return this.validatePermission(FunctionSalesforce.TICKET_OPENING);
    }
}
